import React from 'react';
import { useLocation, Switch, Route } from 'react-router-dom';
import {CSSTransition} from 'react-transition-group';

import Introduction1 from 'pages/Introduction1';
import Introduction2 from 'pages/Introduction2';
import Introduction3 from 'pages/Introduction3';
import TransitionFrame from 'components/TransitionFrame';


const IntroductionRoutes = () => {
  const location = useLocation();

  return (
    <TransitionFrame>
      <CSSTransition
        key={location.key}
        classNames='fade'
        timeout={500}
      >
        <Switch location={location}>
          
          <Route
            path='/introduction1'
            component={Introduction1}
          />
          <Route
            path='/introduction2'
            component={Introduction2}
          />
          <Route
            path='/introduction3'
            component={Introduction3}
          />
        </Switch>
      </CSSTransition>
    </TransitionFrame>
  )
}

export default IntroductionRoutes;